// Utils
import { getUniqueReactions } from '../../reactions/reactionUtil';
import {
    getReactions,
    getShowAssignments,
    getShowDueDate,
    getLabels,
} from '../../../../common/elements/utils/elementPropertyUtils';

// Types
import { isEmpty } from '../../../../common/utils/immutableHelper';
import { ImMNElement } from '../../../../common/elements/elementModelTypes';
import { TaskPillData } from './taskPillsTypes';

type UniqueReaction = {
    emojiCode: string;
    userIds: string[];
};

export const getTaskPillsList = (element: ImMNElement, permissions: number): TaskPillData[] => {
    const pillsList: TaskPillData[] = [];

    if (getShowDueDate(element)) pillsList.push({ type: 'DUE_DATE', id: 'DUE_DATE' });
    if (getShowAssignments(element)) pillsList.push({ type: 'ASSIGNMENT', id: 'ASSIGNMENT' });

    const reactions = getReactions(element);
    const labels = getLabels(element);

    if (!isEmpty(labels)) {
        pillsList.push({ type: 'LABELS', id: 'LABELS', labelIds: labels, element });
    }

    if (!isEmpty(reactions)) {
        const uniqueReactions: UniqueReaction[] = Object.values(getUniqueReactions(reactions));

        uniqueReactions.forEach(({ emojiCode, userIds }) => {
            pillsList.push({
                type: 'REACTION',
                id: `REACTION-${emojiCode}`,
                emojiCode,
                userIds,
            });
        });
    }

    return pillsList;
};
